/**
 * Whether an event is currently "live" (in progress) from a spectator's point
 * of view: published and the wall clock sits within [start_date, end_date].
 *
 * This is the client-safe mirror of the `in_progress` branch of
 * `calculateVirtualEventStatus` (src/models/eventModel.ts). That canonical
 * function can't be imported into client components because its module pulls in
 * the server-only Supabase admin client, so the small amount of logic is
 * duplicated here and pinned to the original by a parity unit test.
 */
export function isEventLive(
  event: { status: string | null; start_date: string; end_date: string },
  now: Date = new Date(),
): boolean {
  if (event.status !== 'published') return false;
  const start = new Date(event.start_date);
  const end = new Date(event.end_date);
  return start <= now && end >= now;
}
